const dayjs = useDayjs()

// 
// FAT Drawer
// 
export function useFatDrawer() {
  const isOpen = useState('fat-drawer', () => false)

  const toggleDrawer = () => {
    isOpen.value = !isOpen.value
  }

  const openDrawer = () => {
    isOpen.value = true
  }

  const closeDrawer = () => {
    isOpen.value = false
  }

  return {
    isOpen,
    toggleDrawer,
    openDrawer,
    closeDrawer,
  }
}

// 
// FAT Time Settings
// 
export function useFatTimeSettings() {
  const isOpen = useState('fat-time-settings', () => false)

  const toggleTimeSettings = () => {
    isOpen.value = !isOpen.value
  }

  return {
    isOpen,
    toggleTimeSettings,
  }
}

// 
// FAT Toggle tag ID
// 
export function useFatQuery() {
  const app = useAppStore()
  const fat = useFatStore()
  const dayjs = useDayjs()
  const route = useRoute()
  const tagIds = computed(() => route.query?.tagIds?.split(',')?.map(Number) ?? [])

  const toggleTagId = (tagId) => {
    !tagIds.value.includes(tagId)
      ? addTagId(tagId)
      : removeTagId(tagId)
  }

  const addTagId = (tagId) => {
    const newQuery = {}

    // These tags can NOT be combined
    const restrictedTags = [1100, 1101, 1102, 1103, 176]
    
    // Get current tag ID's (filter any restricted tags)
    const currentTagIds = restrictedTags.includes(tagId)
      ? tagIds.value.filter(tagId => !restrictedTags.includes(tagId))
      : tagIds.value
    
    // Get new tag ID's with current and new
    const newTagIds = [...new Set([...currentTagIds, tagId])]
    
    // Set dinner time range "offers" tags
    if ([1100, 1101, 1102, 1103].some(tag => newTagIds.includes(tag))) {
      const dinner = app.meals.find(meal => meal.slug === 'dinner')
      newQuery.timeRange = `${dinner.startTime}-${dinner.endTime}`

      // Change date for offers if seven days ahead
      if (dayjs(fat.date).isAfter(dayjs().add(7, 'days'))) {
        newQuery.date = dayjs().format('YYYY-MM-DD')  
      }
    }

    // Set today for tag "sista minuten"
    if (tagId === 1103) {
      newQuery.date = dayjs().format('YYYY-MM-DD')
    }

    // Update time range if tag is "brunch"
    if (tagId === 176) {
      newQuery.timeRange = '11:00-16:00'

      // const selectedDate = dayjs(fat.date)
      // const selectedDay = selectedDate.day() 
      
      // // Check if date is NOT saturday or sunday
      // if (![6, 0].includes(selectedDay)) {
      //   // Calculate the number of days until the next Saturday
      //   newQuery.date = nextSaturday.format('YYYY-MM-DD')
      // }
    }

    // Add new tag ID's to query, set time to 11-16 for "brunch" tag
    useUpdateQuery({
      tagIds: newTagIds?.join(',') || undefined,
      ...newQuery
    })
  }

  const removeTagId = (tagId) => {
    const newTagIds = tagIds.value.filter(id => id !== tagId)
    useUpdateQuery({ tagIds: newTagIds?.join(',') || undefined })
  }

  return {
    toggleTagId,
    addTagId,
    removeTagId,
  }
}

// 
// Get preferred timeslots (from multiple meals)
// 
export function useFatPreferredTimeslots(meals = [], preferredTime = '19:00', limit = 3) {
  if (!meals?.length) return []

  const [preferredHour, preferredMinute] = preferredTime.split(':').map(Number)
  const referenceTime = dayjs().hour(preferredHour).minute(preferredMinute).second(0)

  // Step 1: Flatten and timeslots and add diff
  const allTimeslots = meals.flatMap(meal =>
    meal.timeslots.map(slot => {
      const [hour, minute] = slot.time.split(':').map(Number)
      const slotTime = dayjs().hour(hour).minute(minute).second(0)

      return {
        ...slot,
        diff: Math.abs(slotTime.diff(referenceTime, 'minute')),
      }
    })
  )

  // Step 2: Remove duplicates by exact time string (HH:mm)
  const uniqueTimeslots = useUniqueBy(allTimeslots, 'time')

  // Step 3: Sort by closeness to preferred time
  const closest = uniqueTimeslots
    .sort((a, b) => a.diff - b.diff)
    .slice(0, limit)

  // Step 4: Return them in chronological order
  return closest.sort((a, b) => a.timestamp - b.timestamp)
}
